 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","8":"source~bet-details-page~betting-history-page","9":"source~i18n-widgets-ar-json","10":"source~i18n-widgets-en-json","11":"source~i18n-widgets-fa-json","12":"source~i18n-widgets-ku-json","13":"source~i18n-widgets-tr-json","16":"source~/esports-betting-rules-TR","17":"source~bet-builder-rules-AZ","18":"source~bet-builder-rules-DE","19":"source~bet-builder-rules-EN","20":"source~bet-builder-rules-ES","21":"source~bet-builder-rules-ES-MX","22":"source~bet-builder-rules-ET","23":"source~bet-builder-rules-FI","24":"source~bet-builder-rules-FR","25":"source~bet-builder-rules-IT","26":"source~bet-builder-rules-JA","27":"source~bet-builder-rules-KA","28":"source~bet-builder-rules-LT","29":"source~bet-builder-rules-LV","30":"source~bet-builder-rules-PL","31":"source~bet-builder-rules-PT-BR","32":"source~bet-builder-rules-RO","33":"source~bet-builder-rules-RU","34":"source~bet-builder-rules-SQ","35":"source~bet-builder-rules-SV","36":"source~bet-builder-rules-TR","37":"source~bet-details-page","38":"source~betting-history-container","39":"source~betting-history-page","40":"source~betting-rules-AZ","41":"source~betting-rules-DA","42":"source~betting-rules-DE","43":"source~betting-rules-EN","44":"source~betting-rules-ES","45":"source~betting-rules-ES-MX","46":"source~betting-rules-FR","47":"source~betting-rules-IT","48":"source~betting-rules-JA","49":"source~betting-rules-PL","50":"source~betting-rules-PT","51":"source~betting-rules-PT-BR","52":"source~betting-rules-RO","53":"source~betting-rules-RU","54":"source~betting-rules-SQ","55":"source~betting-rules-SV","56":"source~betting-rules-TR","57":"source~bonus-info","58":"source~cashout-terms-AR","59":"source~cashout-terms-AZ","60":"source~cashout-terms-DA","61":"source~cashout-terms-DE","62":"source~cashout-terms-EN","63":"source~cashout-terms-ES","64":"source~cashout-terms-ES-MX","65":"source~cashout-terms-ET","66":"source~cashout-terms-FI","67":"source~cashout-terms-FR","68":"source~cashout-terms-IT","69":"source~cashout-terms-JA","70":"source~cashout-terms-KA","71":"source~cashout-terms-KU","72":"source~cashout-terms-LT","73":"source~cashout-terms-LV","74":"source~cashout-terms-PL","75":"source~cashout-terms-PT","76":"source~cashout-terms-PT-BR","77":"source~cashout-terms-RO","78":"source~cashout-terms-RU","79":"source~cashout-terms-SQ","80":"source~cashout-terms-SR","81":"source~cashout-terms-SV","82":"source~cashout-terms-TR","83":"source~esports-betting-rules-AZ","84":"source~esports-betting-rules-DA","85":"source~esports-betting-rules-DE","86":"source~esports-betting-rules-EN","87":"source~esports-betting-rules-ES","88":"source~esports-betting-rules-ES-MX","89":"source~esports-betting-rules-ET","90":"source~esports-betting-rules-FI","91":"source~esports-betting-rules-FR","92":"source~esports-betting-rules-IT","93":"source~esports-betting-rules-JA","94":"source~esports-betting-rules-KA","95":"source~esports-betting-rules-LT","96":"source~esports-betting-rules-LV","97":"source~esports-betting-rules-PL","98":"source~esports-betting-rules-PT","99":"source~esports-betting-rules-PT-BR","100":"source~esports-betting-rules-RO","101":"source~esports-betting-rules-RU","102":"source~esports-betting-rules-SQ","103":"source~esports-betting-rules-SR","104":"source~esports-betting-rules-SV","106":"source~generated-mappings","107":"source~i18n-ar-json","108":"source~i18n-en-json","109":"source~i18n-fa-json","110":"source~i18n-ku-json","111":"source~i18n-tr-json","113":"source~settings-page","114":"source~streaming-carousel","115":"source~virtual-esports-betting-rules-AZ","116":"source~virtual-esports-betting-rules-EN","117":"source~virtual-esports-betting-rules-IT","118":"source~virtual-esports-betting-rules-JA","119":"source~virtual-esports-betting-rules-PL","120":"source~virtual-esports-betting-rules-RU","122":"vendors~rc-slider","123":"vendors~react-google-recaptcha","124":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"0b92c351968f92c7c80f","1":"69ab3547fac40c55ea43","2":"128e15d03f62f60c86c5","3":"003f2202d33ef315126c","4":"ee7814896dfd1c8433c0","5":"207ea0a34637e2ed55d6","6":"81aa6936c6eeb49feae5","8":"5f10ade496db2a17550f","9":"9e4d5a2b2afd31d696cb","10":"c2a86e3b20465904a5bd","11":"240da56dad92ed305eb9","12":"e13d026d747367f85cba","13":"181a0991757edc97a3d3","16":"254127af95d036f8508d","17":"01d7a04dcb6c89021d03","18":"acb0c1e7a82209289371","19":"fcb0a9a717820a3c060a","20":"a6283cad2b095ed601ec","21":"de97687b9365caed55b9","22":"4d43f71e1306ec4f3bcd","23":"df14df1c38d59d19cebd","24":"3f31a0587b1b3bbba8ef","25":"cdb917f98e2d15f01053","26":"60eb0af8b8a0dbe540f9","27":"4e851ed1cbd3a2d7aa9a","28":"4a545919487e4065ba5c","29":"6d5e85416ee83564f893","30":"3bba181d94ae46ce4c7e","31":"0f4e57a01be6b512a400","32":"bfe65fa8c1f0f203d13e","33":"6de4a56f6fb19b7783d6","34":"93ea35bc47f036ee70c8","35":"52be1274fd6ef25e0c71","36":"8edb3469b9e107edb77b","37":"9e71b87884e2c58fc7df","38":"41d3463b33dbfe61dab8","39":"e7a25aa93eab607032de","40":"2c3c1807c1c389f11571","41":"b20b20d7d7041172796b","42":"fd707a4d1f89862c3291","43":"6a3c78b46158cb61a433","44":"d8281e56afbbf0ea2f48","45":"673433dc32e6f9d844f7","46":"102d6f1065aa6c05aa29","47":"8c470c3688a9d2e230b0","48":"c9403985b17aed55ca54","49":"684536f8b822872f13af","50":"882d1a10a3aba4dd1b35","51":"528f10641bcf44bf1061","52":"0e7794529c144a704bfe","53":"3623bbd580248c6f5d2a","54":"4df9120d6503d8474aef","55":"ff41dbfa105217f9c610","56":"49672871324619c90491","57":"53095093e208b38eaac0","58":"554f8101212dea582955","59":"e52b23bbd2c8be401e69","60":"c84a7342d46c32fe11bc","61":"58a9003018e8f6afea47","62":"690c64f998bfe13170e4","63":"769ad585a726da39f392","64":"40f552095a95b0a07697","65":"3ce26dfb91598b08b679","66":"321cc6f43a33509a55fc","67":"a786289528ed7cc72935","68":"144f5e7d53ff1b4161d2","69":"89f1f021f1810c8ada69","70":"49ee0bb933ccf276e90b","71":"7a468ffbc91740eca331","72":"51699d7a4f02175c3d9b","73":"8a7f8e1aeb899a7b4db2","74":"65e42060a26421999ae8","75":"619fff67b67bc37fa4c5","76":"712f52d9e38bad8c0826","77":"9e0f1c10e3f7fae8af32","78":"d3ffaad8eac48684807a","79":"0ea66ebfbec0129cc027","80":"7b82f3e8b3ff039449bc","81":"0df9f23f2400a3d937fe","82":"f3b7cb77c72bcfe0dff9","83":"01088745b2485538c058","84":"216b996eea318b48fc68","85":"15d3d60d14e8c333dc8b","86":"6596ecd513c4cea90d33","87":"ebfdc8f18648525b9cbd","88":"a2ddf73ce48eade950d5","89":"136e12414a41def9d8f5","90":"3a0b83497560abfe0ae2","91":"43449dc1e17b51096876","92":"d4b58088eff722fad6a9","93":"b71c4869722fdcd2ecf8","94":"9d837c9176b79652fd8c","95":"88eff2aac604a45ae837","96":"98a418e6707079fccba5","97":"bf2cbd4a589d9d933e41","98":"e47b5732d7716abd5b3a","99":"b4dd768c95e6197997a6","100":"4cb7cdb047b58e528fdf","101":"88bd3b49e890fc2c6184","102":"ee7b0a4a009b61bf0a8f","103":"c2449041deeb6ada10f0","104":"4f90bf13bee26f82a9cc","106":"addb7f5a7ec39b367fb0","107":"bf45958e61b910c1e6fb","108":"cd74521cd08156a28865","109":"1c2a9850e226d850131a","110":"a8d76ac47f302c4ec962","111":"50240dd31a9b179098b5","113":"db66c9c6f262a1b990ae","114":"ac04fd6ab706ebd94d47","115":"01cc053e7fad2149ca2d","116":"009965e4ee546f1d699f","117":"e0cdee70590e87bcba3c","118":"5a17f53cc69bbc9c394f","119":"f70fdecf668655622870","120":"bb707839f0956574df4c","122":"357c9287d0e2b85197e2","123":"281f086dacffe9eaa237","124":"3186f65701402703ad3e","125":"d3546c1cd49cde87b362","126":"92040a0a9de8fddad753","127":"2f11cc4bcd7689a3913e","128":"7ed536da87947c485e79","129":"60bac9ef0621aabadf94","130":"784cc3b10a76d7dcc81c","131":"b26cd2259d0137b0322b","132":"8e188e2a0ffa528fefd7","133":"36244e5e66f7317434e1","134":"876c833336db2feb3b3d","135":"9681f0639b558f34945c","136":"61ba07f1bc43ed73c12f","137":"6e1fbd781d3c27d207ac"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
